import React, { memo, useMemo } from 'react';
import pick from 'lodash/pick';
import { HighlightedPolygonBox } from 'pages/document/page/components/Polygons/highlightedPolygons/highlightedPolygon/StyledComponent';

function HighlightedPolygon({ children, style }) {
  const polygonStyles = useMemo(() => {
    const { width, height, top, left } = style;

    return {
      width,
      height,
      top,
      left,
      userSelect: 'none',
    };
  }, [style]);

  return (
    <HighlightedPolygonBox role="toolbar" draggable="false" style={polygonStyles}>
      <div style={pick(polygonStyles, ['height', 'width'])}>{children}</div>
    </HighlightedPolygonBox>
  );
}

export default memo(HighlightedPolygon);
